import React from 'react';
import './about.scss'

const About = () => {
  return (
    <h1 className='about'>
      We are awesome!!!
    </h1>
  );
};

export default About;